<template>
<div class="container-fluid" >

<waitingModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal"></waitingModal>
<div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:#FFD700" class="fas fa-chart-area mr-2" aria-hidden="true"></i>SELL OUT TUTTI I FORNITORI </h4>
  </div> 

 <div  class="card-body"> 
  <div class="row">
  <div v-if="items.length==0" class="col"> 

  <div  class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-black">

  <form name="filter" v-on:submit.prevent="getData()">

  <div class="row">
    <div class="col-md-4">
        <collectionSelect  v-bind:props="collection" @update="setCollectionId"></collectionSelect>                        
        <collectionOptionType class="ml-3 mb-3" v-bind:typeId="collection.typeId" v-bind:option="1"  @update="setCollectionTypeId"></collectionOptionType>        
    </div>
  </div>  
  <div class="row">
    <div v-if="1==0" class="form-group col-md-4">
    <label for="date_doc"><strong>DATA ULTIMO ACQUISTO / RESO A FORNITORE</strong></label>
    <div class="input-group">  
    <input  v-model="data2" type="date" class="form-control" placeholder="" >         
    
    </div>
  </div>

  <div class="form-group col-md-4">
        <label for="date_doc"><strong>DATA ULTIMA VENDITA</strong></label>
        <input  v-model="data3" type="date" class="form-control" placeholder="" >        
  </div>  
  
  </div>
  
    <div class="row">
    <div class="col-md-3">  
      <store-select v-bind:props="store"  @update="setStoreId"></store-select>     
    </div>
   
    <div class="col-md-2">    
      <season-vue-select  @update="setSeasonId" v-bind:props="season"></season-vue-select>
    </div>
   
    <div class="col-md-2">  
      <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    </div>
    
    <div class="col-md-2">          
      <departmentVueSelect v-bind:props="department" @update="setDepartmentId"></departmentVueSelect>
    </div>  
    <div class="col-md-3"> 
    <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>
    </div>
    </div>    
    
  
  <span><strong>TIPO RAGGRUPPAMENTO</strong></span>  
  
  <div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios0" id="exampleRadios0" value="0" v-model="group_by"  checked>
  <label class="form-check-label" for="exampleRadios0">
    FORNITORE
  </label>
  </div>

  
  <div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios1" id="exampleRadios1" :value="1" v-model="group_by">
  <label class="form-check-label" for="exampleRadios1">
    BRAND
  </label>
  </div>

  <div class="form-check mb-1">
  <input class="form-check-input" type="radio" name="exampleRadios3" id="exampleRadios3" value="3" v-model="group_by" >
  <label class="form-check-label" for="exampleRadios3">
    BRAND - GRUPPO/CATEGORIA
  </label>
  </div>


  <div class="form-check mb-1">
  <input class="form-check-input" type="radio" name="exampleRadios2" id="exampleRadios2" value="2" v-model="group_by" >
  <label class="form-check-label" for="exampleRadios2">
    CATEGORIA
  </label>
  </div>

  
  <span><strong>TIPO REPORT</strong></span> 
  <div class="form-check ">
    <input @click="department.isActive = false" class="form-check-input" type="radio" name="inlineRadioReport1" id="inlineRadioReport1" value="1" v-model="reportId">
    <label class="form-check-label" for="inlineRadioReport1">SINTETICO</label>
  </div>
  <div class="form-check mb-1">
    <input @click="department.isActive = true" class="form-check-input" type="radio" name="inlineRadioReport2" id="inlineRadioReport2" value="2" v-model="reportId">
    <label class="form-check-label" for="inlineRadioReport2">ANALITICO</label>
  </div>
  

  <div v-if="reportId==1">
  <span ><strong>TIPO ORDINAMENTO</strong></span> 
  <div class="form-check ">
    <input  class="form-check-input" type="radio" name="inlineRadioOptionsOrder1" id="inlineRadio1Order" value="1" v-model="orderBy">
    <label class="form-check-label" for="inlineRadio1Order">DELTA QUANTITA'</label>
  </div>
  <div class="form-check mb-2">
    <input  class="form-check-input " type="radio" name="inlineRadioOptionsOrder2" id="inlineRadio2Order" value="2" v-model="orderBy">
    <label class="form-check-label" for="inlineRadio2Order">BEP</label>
  </div>
  </div>




   <div class="card-footer bg-transparent border-info"> 
     <!--
     <button @click="items=[],row_total=[]" type="button"   class="btn btn-outline-secondary float-left">
       <i class="fas fa-redo-alt mr-2"></i>
      
        RESET
    </button>   
    -->
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
   <button :disabled="spinner" type="submit"  class="btn btn-primary float-left">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI
      <!--<span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>-->
     </button>           

  

</div>

</form>

</div>
</div>
</div>



<div v-else class="col">

<filter-cols  @update="setFilter" v-bind:header="header_col" ></filter-cols>


<!-- REFRESH ON FILTERING-->
<div v-if="filter">

 <cancel-btn @click="items=[],row_total=[]" class="mb-1" v-bind:text="'RITORNA A PARAMETRI RICERCA'"></cancel-btn>
 <div class="row">
  
    <button type="button" class="btn btn-info ml-3 mb-1 mr-3 " data-toggle="modal" data-target="#filterModal">
      <i class="fas fa-filter mr-2"></i>
      FILTRA COLONNE
    </button>  

    <button :disabled="items.length==0 || spinner_pdf == true" @click="pdf()" type="button"   class="btn btn-primary mb-1 mr-3 ">
      <i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>  
    
     <button v-if="1==0"  @click="setParams()" type="button"   class="btn btn-warning mb-1 ml-4">
      <i class="fas fa-chart-pie mr-2"></i>
      GRAFICO VENDUTO (ie) €
      
    </button>  
    
    
    <div class="col"></div>
    <h4 class="float-right mr-4"><strong>VALORI IN € IVA ESCLUSA</strong></h4>  
    
  </div>
    
  <chartModal v-if="1==0" @close="params.companyId=0" v-bind:params="params"></chartModal>

    <div class="table-wrapper-scroll-y my-custom-scrollbar">

    <table id='my-table' class="table table-hover table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>
        
         
          <th v-if="reportId == 1 && group_by == 0">FORNITORE</th>        
          <th v-if="reportId == 1 && group_by == 1">BRAND</th>        
          <th v-if="reportId == 1 && group_by == 2">CATEGORIA</th>     
          <th v-if="reportId == 1 && group_by == 3">BRAND - GRUPPO</th>        


          
          <th v-if="reportId == 2 ">FORNITORE</th>        
          <th v-if="reportId == 2 ">BRAND</th>        
          <th v-if="reportId == 2 ">GRUPPO</th>        
          <th v-if="reportId == 2 ">CATEGORIA</th> 
          
        
        <th v-if="reportId == 2" scope="col">STAGIONE</th>   
         

        <th v-if="reportId == 2" scope="col">REPARTO</th>
       
        <th class="text-right" scope="col">ACQUISTATO</th>        
        <th class="text-right" scope="col">VENDUTO</th>
        <th class="text-right" scope="col">DELTA</th>
        
        
        <th class="text-right text-nowrap" scope="col">ACQUISTATO €</th>
        <th class="text-right text-nowrap" scope="col">VENDUTO €</th>
        <th v-if="col[0]" class="text-right text-nowrap filter">COSTO VENDUTO (€)</th>
        <th class="text-right">SELLOUT</th>
       
        <th  v-if="col[1]" class="text-right filter">BEP</th>
        
        <th v-if="col[2]" class="text-right text-nowrap filter" scope="col">VEND. RETAIL </th>
        <th v-if="col[3]" class="text-right text-nowrap filter" scope="col">VEND. ONLINE </th>
        <th  v-if="col[4]" class="text-right text-nowrap filter" scope="col">VEND. ONLINE €</th>
                
        <th v-if="col[5]" class="text-right filter" scope="col">STOCK</th>
        <th v-if="col[6]" class="text-right text-nowrap filter" scope="col">VAL. STOCK €</th>
       
       <th  v-if="col[7]" class="text-right text-nowrap filter">UTILE €</th>
       <th  v-if="col[8]" class="text-right filter">MARGINE</th>
       
      </tr>
    </thead>
    <tbody>
      <tr :style="{backgroundColor: item.row_type == 1 ? 'white':'white', color: item.row_type==1  ? 'blue' : 'black',fontSize: item.row_type == 1 ? '16px':'14px',fontWeight:item.row_type == 1? 'bold':'normal' }"   data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">
        <td > 
          <input :disabled="true" type="checkbox"  v-model="item.selection">
        </td> 
        
       
          <td v-if="reportId == 1 && group_by == 0" class="text-nowrap">{{ item.supplier }} </td>   
          <td v-if="reportId == 1 && group_by == 1" class="text-nowrap">{{ item.brand }} </td>   
          <td v-if="reportId == 1 && group_by == 3" class="text-nowrap">{{ item.cat_grouping }}  </td>   
          <td v-if="reportId == 1 && group_by == 2" class="text-nowrap">{{ item.category }} </td>   
          
          
          <td v-if="reportId == 2" class="text-nowrap">{{ item.supplier }} </td>   
          <td v-if="reportId == 2" class="text-nowrap">{{ item.brand }} </td>   
          <td v-if="reportId == 2" class="text-nowrap">{{item.cat_grouping}} </td>   
          <td v-if="reportId == 2" class="text-nowrap">{{ item.category }} </td>   
          

    

       <td v-if="reportId==2" class="text-nowrap">{{item.season}} {{item.season_year}}</td>       
        
        <td v-if="reportId==2" >{{item.department}}</td>        
      <!--  <td >{{item.season_year}}</td>     -->   
        
        <!--
        <td >{{item.department}}</td>        
        <td >{{item.brand}}</td>   
        <td >{{item.line}}</td>   
        <td >{{item.cat_grouping}} </td>        
        <td>{{item.category}} </td>
        -->
        <td class="text-right">{{fmt2(item.acquistato_qty)}} </td>        
        <td class="text-right">{{fmt2(item.venduto_qty)}}</td>
        <td class="text-right">{{item.delta_qty}} %</td>
        
        
        <td class="text-right">{{fmt1(item.acquistato_value)}}</td>
        <td class="text-right">{{fmt1(item.venduto_no_iva)}}</td>
        <td v-if="col[0]" class="text-right ">{{fmt1(item.costo_venduto)}} </td>        
        <td  class="text-right">
          {{item.delta_sellout}}
          <div class="progress" style="height: 12px;">
            <div class="progress-bar bg-info" role="progressbar" :style="{width: item.delta_sellout}"  aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          
           </td>
        <td :style="{color :  item.delta_venduto.substring(0,1) =='-' ? 'red':'green'}" v-if="col[1]" class="text-right ">{{item.delta_venduto}} </td>
        
        <td  v-if="col[2]" class="text-right ">{{fmt2(item.venduto_retail_qty)}}</td>
        <td  v-if="col[3]" class="text-right ">{{fmt2(item.venduto_online_qty)}}</td>
        <td   v-if="col[4]" class="text-right ">{{fmt1(item.venduto_online_value)}}</td>
        
        
        <td  v-if="col[5]" class="text-right ">{{fmt2(item.stock_qty)}} </td>
        <td  v-if="col[6]" class="text-right ">{{fmt1(item.stock_value)}} </td>        
        <td :style="{color :  fmt1(item.utile).substring(0,1) =='-' ? 'red':'green'}"  v-if="col[7]" class="text-right ">{{fmt1(item.utile)}} </td>
        <td  v-if="col[8]" class="text-right ">
        
         {{item.margine}}
         
         </td>
        
       
      </tr> 
    </tbody>
    <tfoot>
        <tr  v-for="(item, index) in row_total" :key="index"> 
        
       
        <td v-if="reportId==2"></td>             
        <td v-if="reportId==2"></td>             
        <td v-if="reportId==2"></td>             
        <td v-if="reportId==2"></td>  
        <td v-if="reportId==2"></td>  
        <td ></td>      
        
        
        
        
        <td>TOTALI </td>
        <td class="text-right">{{fmt2(item.acquistato_qty)}} </td>        
        <td class="text-right">{{fmt2(item.venduto_qty)}}</td>
        <td class="text-right">{{item.delta_qty}} %</td>
        
        
        <td class="text-right">{{fmt1(item.acquistato_value)}}</td>
        <td class="text-right">{{fmt1(item.venduto_no_iva)}}</td>
        <td v-if="col[0]" class="text-right">{{fmt1(item.costo_venduto)}} </td>        
        <td class="text-right">{{item.delta_sellout}} </td>
        <td  :style="{color :  item.delta_venduto.substring(0,1) =='-' ? 'red':'black'}"  v-if="col[1]" class="text-right">{{item.delta_venduto}} </td>
        
        <td v-if="col[2]" class="text-right">{{fmt2(item.venduto_retail_qty)}}</td>
        <td v-if="col[3]" class="text-right">{{fmt2(item.venduto_online_qty)}}</td>
        <td v-if="col[4]" class="text-right">{{fmt1(item.venduto_online_value)}}</td>       
        <td v-if="col[5]"  class="text-right">{{fmt2(item.stock_qty)}} </td>
        <td v-if="col[6]" class="text-right">{{fmt1(item.stock_value)}} </td>        
        <td :style="{color :  fmt1(item.utile).substring(0,1) =='-' ? 'red':'black'}" v-if="col[7]" class="text-right">{{fmt1(item.utile)}} </td>
        <td  v-if="col[8]" class="text-right">{{item.margine}} </td>
               
        </tr>   
    </tfoot>    
  </table>

</div>

</div>
</div>  

</div>

<!-- card body -->
 </div>

 </div>
  
  
    
 



</div>


</template>
<script>

import api               from '@/api'
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import seasonVueSelect   from '@/components/common/SeasonVueSelect_1.vue'
import yearSelect        from '@/components/common/YearVueSelect.vue'
import departmentVueSelect  from '@/components/common/DepartmentVueSelect.vue'
import storeSelect       from '@/components/common/StoreSelect_1.vue'
import filterCols        from '@/components/common/ModalFilterCols.vue'
import jsPDF             from 'jspdf'
import cancelBtn         from '@/components/common/CancelBtn.vue'
import fmt               from '@/components/mixins/fmt'
import chartModal        from '@/components/gchart/gchart2.vue'  
import waitingModal      from "@/components/common/WaitingModal.vue"
import {setFmtDate1}     from '@/functions'   
import collectionSelect        from '@/components/common/CollectionSelect_1.vue' 
import collectionOptionType    from '@/components/backOffice/CollectionOptionType.vue' 
import categoryGrouping   from '@/components/common/CategoryGroupingSelect_1.vue'



//import 'jspdf-autotable'
//import autoTable from 'jspdf-autotable'



export default {
  mixins     : [fmt],
  components: {alertBox,yearSelect,storeSelect,filterCols,cancelBtn,chartModal,waitingModal,seasonVueSelect,departmentVueSelect,collectionSelect,collectionOptionType,categoryGrouping},
  data() {
    return {
      
      reportId        : 1,  
      collection      : 
      {
        Id            : 0,
        isActive      : true,       
        optionBase    : false,
        required      : true,
        typeId        : 3
      },  
      orderBy      : 1,
      waitModal    : {

            sentinel   : 0,
            show       : false,
            msg1       : 'ELABORAZIONE IN CORSO ...',
            msg2       : '' 

      },

      btn_chart       : false,
      params          : {companyId:0},
      checkBox        : true,
      total_rows      : true,
      temp_rows       : [],
      header_col      : [],
      col             : [],
      filter          : true,

      store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false
      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : false,
        required      : false,
        Ids           : '',
        selection     : []
      },
      department      : 
      {
        Id            : 0,
        isActive      : false,
        type          : true,
        optionBase    : true,
        required      : false,
        Ids           : '',
        selection     : []
      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        Ids           : '',
        selection     : []

      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },  

      title           : {store : 'Tutte',department:'Tutti'}, 
      data1           : null,
      
      data2           : new Date().toISOString().slice(0,10),
      data3           : new Date().toISOString().slice(0,10),
      data4           : new Date().toISOString().slice(0,10),      
      spinner         : false,
      spinner_pdf     : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : [],
      
      group_by        : 0,
      bt_spinner      : false,
     
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

   // this.getGrouping()
   //this.department.isActive = this.typeId == 2
  },
  methods: {

    setGroupCategoryId(Id,e)
    {
      
      

      this.catGrouping.Id = Id
      
      //this.pdf_title.catGroup = e.target.options[e.target.options.selectedIndex].text  
      if(Id == 0)
      {
        //this.pdf_title.catGroup = ''
      }

    
    },
   setCollectionId(Id,e)
    {
      
      this.collection.Id = Id
      //this.pdf_title.collection = e.target.options[e.target.options.selectedIndex].text 
      

    },
    setCollectionTypeId(Id)
    {
      this.collection.typeId = Id
      
    },  
  setFmt(data)  
  {
    if(data)
    {
     return setFmtDate1(data)
    }  
  },
  resetData()
  {
    //this.data1 = null
    //this.data2 = null

  },
  closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },
  setGroupBy(Id)
  {
    const group_by = ['FORNITORE','BRAND','CATEGORIA']
    return group_by[Id]
  },  

  setParams()
  {
    this.params.sp        = 'spSellOutAllSuppliersChartData'
    this.params.companyId = this.company.Id
    this.params.storeId   = this.store.Id
    this.params.data1     = this.data1
    this.params.data2     = this.data2
    this.params.data3     = this.data3
    this.params.seasonId  = this.season.Id
    this.params.year      = this.season_year.year



  } , 
  showAllCols()
  {
    for (let i = 0; i < 9; i++) {
          this.col[i]= true
          } 

  },
  setFilter(cols)
  {
        
    this.filter = false
     for (let i = 0; i < cols.length; i++) 
     {
          this.col[i] = cols[i]['selected']
         
     } 
    this.filter = true      
        
  },  
   
   async  pdf()
    {

      
      const addFooters = doc => {
      const pageCount = doc.internal.getNumberOfPages()
      doc.setFont('helvetica', 'italic')
      doc.setFontSize(8)
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)

        doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
        align: 'center'})
      }
      }
       
       this.spinner_pdf = true


       const doc = new jsPDF(
         
         {
         
       orientation: "landscape",

        
      })
      doc.setFontSize(8)
      var d = new Date();
      var n = d.toLocaleDateString();
      var t = d.toLocaleTimeString();
      doc.text("SELL OUT FORNITORI DEL " + n + ' ' + t , 15, 10);
      doc.setFontSize(10)
      //doc.text('Sede ' + this.title.store + ' - Stagione ' + this.title.season + ' ' + this.title.year + ' - Reparto ' + this.title.department, 15, 15);
      doc.text('SEDE ' + this.title.store , 15, 15);
      doc.autoTable(
      
    
       { html: '#my-table',
       margin       : {top:20},
       showFoot: 'lastPage',
       
       //theme          : 'grid',

        columnStyles : {
          
          3:{
                halign:'right'
          },
          4:{
                halign:'right'
          },
          5:{
                halign:'right'
          },
          6:{
                halign:'right'
          },
          7:{
                halign:'right'
          },
          8:{
                halign:'right'
          },
          9:{
                halign:'right'
          },
          10:{
                halign:'right'
          },
          11:{
                halign:'right'
          },
          12:{
                halign:'right'
          } ,
          13:{
                halign:'right'
          },
          14:{
                halign:'right'
          },
          15:{
                halign:'right'
          },
          16:{
                halign:'right'
          },
          17:{
                halign:'right'
          },
          18:{
                halign:'right'
          },
          19:{
                halign:'right'
          },
          20:{
                halign:'right'
          } 

       },
       footStyles:{halign:'right',fontStyle:'bold',fillColor:'white',textColor:'black',fontSize:7,cellWidth: 'wrap',},

          didParseCell: function(data) {
            if (data.row.cells[0].text == 'Tot. Raggruppamento') {
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 6
              //console.log(data.row.cells[0].text)

            }
          


          
          }, 



       styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 7,
          }
        })
      
     
     addFooters(doc) 
    //var string = doc.output('datauristring');
    //doc.output('dataurlnewwindow');
    const fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    //console.log(string)
    this.spinner_pdf = false
    //doc.save('sellOut_' + Date.now()  + '.pdf', {returnPromise:true}).then(this.spinner_pdf=false);
      
     
    },
   
 
    
    setDepartmentId(Ids,text)
    {
      

      /*this.department.Id = departmentId
      this.title.department = e.target.options[e.target.options.selectedIndex].text
      */      
      //this.resetData()
      //this.title.department = text  

      this.department.selection = Ids
      let departmentIds = ''
      if (Ids.length > 0)
      {
        departmentIds = Ids.join() 
      }
       
      this.department.Ids = departmentIds


    },
    
    setSeasonId(Ids,text,seasonId,e)
    {   
       /*
        this.season.Id = seasonId
        this.title.season = e.target.options[e.target.options.selectedIndex].text
        */
      //this.resetData() 
      //this.title.season = text  
      this.season.selection = Ids
      let seasonIds = ''
      if (Ids.length > 0)
      {
        seasonIds = Ids.join() 
      }
       
      this.season.Ids = seasonIds
      //console.log(seasonIds)

    }, 
    setYear(Ids,text)
    {
      
      let items = ''      
      //this.pdf_title.year   = text
      this.season_year.selection = Ids
           
      if (Ids.length > 0)
      {
        items = Ids.join() 
      }
      this.season_year.Ids = items
         

    },     
  
     setStoreId(storeId,e)
    {
      //this.resetData()
      this.store.Id = storeId
      this.title.store = e.target.options[e.target.options.selectedIndex].text  
    },  
       
    async getData() {

      this.showAllCols()
      this.row_total = []
      this.items     = []
            
      this.msg.title = ''
      const sp = {'sp' : 'spSellOutAllSuppliersType' + this.reportId  + 'Collection'}           
      
      const data  = {

        'companyId'    : this.company.Id,
        'data1'        : this.data1,
        'data2'        : this.data2,
        'data3'        : this.data3,
        'seasonId'     : this.season.Ids,
        'year'         : this.season_year.Ids,
        'departmentId' : this.department.Ids,
        'storeId'      : this.store.Id,
        'group_by'     : this.group_by,
        'typeId'       : this.reportId,
        
        'orderBy'      : this.orderBy,
        'collection'   : this.collection,
        'catGroupId'   : this.catGrouping.Id
      
      }
      
      const json  = Object.assign(data, sp)

      this.spinner = true
      this.waitModal.show = true
      await api.post(json).then(async res => {
         
          if(res.status==200)
            {
              this.waitModal.sentinel = 1
              if(this.reportId == 1)
              {
                this.items = res.data.recordsets[0].filter(item=>item.row_type==0 )
              }
              else
              {
                
                this.items = res.data.recordsets[0].filter(item=>item.row_type==0 || item.row_type == 1)
                
              }
                                        
              this.items.forEach(item=>{
              item.selection = 1 
             
            })
            
            if(this.reportId == 1)
            {
                this.row_total = res.data.recordsets[0].filter(item=>item.row_type==1)
            }
            else
            {
                this.row_total = res.data.recordsets[0].filter(item=>item.row_type==3)
            }
            
            this.btn_chart = this.row_total[0].venduto_online_qty  > 0 ? true : false           
            this.$nextTick(() =>
               {                 
                 this.header_col = []                   
                 const collection = document.getElementsByTagName("th")                 
                
                 for (let i = 0; i < collection.length; i++) 
                 {
                    if(collection[i].className.indexOf("filter") > 0)
                    {
                      this.header_col.push({'col' : collection[i].innerHTML,'selected':true})
                    }
                                        
                  } 
                                      
              })
            
            if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            this.waitModal.sentinel = 2
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
                
                        

          }
      }).catch(err=>{
            this.waitModal.sentinel = 3
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
              

      }).finally(() => {
          this.spinner = false
        });
      
 

    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 700px;
overflow   : auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 22px;
    background   : rgb(195, 230, 98);
    font-weight  : bold;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }


.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.card-header
{
  _height: 45px;
}
.btn-warning{
  background-color : rgb(193, 193, 126);
    color            : black ;
  
}
.progress {
  background-color: #aaa;
 
}
.group
{
  color: green;
  font-size: 22px;
  
}
/*
input[type=date]:invalid {
  border : 2px solid #c91c1c;
}
input[type="date"]:valid {
  border: 2px solid green;
}
  */
</style>